export const aprilAddress = "0xbfeA674ce7d16E26E39e3c088810367a708eF94C"
export const unlockMonthly = "0xF19F3Eef84CfB45C8a1eD8d3dBBa9842e1407da0"
export const unlockyearly = "0x768D0dD9aF0270aF3710c90ADbEedD8528E7879C"